<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Lots" | tenantWords}}</h2>
      <span class="page-subtitle">Track {{"Lot" | tenantWords}} quantities, locations, and attributes</span>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="header-btn" (click)="exportExcel()">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
      <button *ngIf="this.isAdmin" mat-raised-button color="primary" class="header-btn primary-btn" (click)="createLot()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Create {{"Lot" | tenantWords}}
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
      (filterResultsChange)="setFilterResults($event)">
    </kw-filter-dropdown>
  </div>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.lots" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowTextWrap]="true"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      [aggregates]="this.aggregates"
      (actionBegin)="actionBegin($event)" (dataBound)="onDataBound()"
      (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let lot of this.lots | slice:0:mobileVisibleCount; trackBy: trackByLot" (click)="openDashboard(lot)">
      <div class="m-card-top">
        <span class="m-card-name">{{"Lot" | tenantWords}} {{lot.lotNumber}}</span>
        <span class="type-pill">{{lot.totalQtyOnHand | number}} on hand</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="lot.productCust">
          <fa-icon [icon]="faBox" class="m-meta-icon"></fa-icon>{{lot.productCust}}
        </div>
        <div class="m-meta-line" *ngIf="lot.varietyName">
          <fa-icon [icon]="faSeedling" class="m-meta-icon"></fa-icon>{{lot.varietyName}}
        </div>
        <div class="m-meta-line" *ngIf="lot.farmName || lot.blockName">
          <fa-icon [icon]="faTractor" class="m-meta-icon"></fa-icon>{{lot.farmName}}<ng-container *ngIf="lot.farmName && lot.blockName"> · </ng-container>{{lot.blockName}}
        </div>
        <div class="m-meta-line" *ngIf="lot.locationCust">
          <fa-icon [icon]="faLocationDot" class="m-meta-icon"></fa-icon>{{lot.locationCust}}
        </div>
      </div>

      <div class="m-card-foot">
        <span class="m-card-note" *ngIf="lot.weight">{{"Weight" | tenantWords}} {{lot.weight | number}}</span>
        <span class="m-card-note" *ngIf="lot.createdDateObj">{{lot.createdDateObj | date:'MM/dd/yyyy'}}</span>
        <div class="m-card-actions">
          <button *ngIf="this.isAdmin" mat-icon-button aria-label="Lot actions" [matMenuTriggerFor]="lotMenu"
            [matMenuTriggerData]="{ lot: lot }" (click)="$event.stopPropagation()">
            <fa-icon [icon]="faEllipsisVertical"></fa-icon>
          </button>
          <button mat-icon-button aria-label="Open lot dashboard" (click)="openDashboard(lot); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.lots.length && !this.isLoading">
      <fa-icon [icon]="faBoxes" class="m-empty-icon"></fa-icon>
      <div>No {{"Lots" | tenantWords}} match your filters</div>
    </div>

    <button class="m-show-more" *ngIf="this.lots.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.lots.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #actionTemplate let-data>
  <div class="row-actions">
    <button mat-icon-button aria-label="Lot actions" [matMenuTriggerFor]="lotMenu"
      [matMenuTriggerData]="{ lot: data }" (click)="$event.stopPropagation()">
      <fa-icon [icon]="faEllipsisVertical"></fa-icon>
    </button>
  </div>
</ng-template>

<mat-menu #lotMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-lot="lot">
    <button mat-menu-item type="button" (click)="editLot(lot)">
      <fa-icon [icon]="faPen" class="me-2"></fa-icon>Edit {{"Lot" | tenantWords}}
    </button>
    <button mat-menu-item type="button" (click)="editProduct(lot)">
      <fa-icon [icon]="faBoxes" class="me-2"></fa-icon>Edit {{"Product" | tenantWords}} Code
    </button>
    <button mat-menu-item type="button" (click)="moveInventory(lot)">
      <fa-icon [icon]="faTruck" class="me-2"></fa-icon>Move {{"Inventory" | tenantWords}}
    </button>
    <button mat-menu-item type="button" (click)="adjustQuantity(lot)">
      <fa-icon [icon]="faSlidersH" class="me-2"></fa-icon>Adjust Quantity
    </button>
  </ng-template>
</mat-menu>
